<!-- make item border gray  -->
<div class="blue_theme">
  <form (ngSubmit)="onSubmit?.()" (keydown.enter)="handleEnter($event)" [formGroup]="formGroup" novalidate="novalidate" [id]="formConfigs.id" autocomplete="off">
    <mat-card-content class="row d-flex" [ngClass]="formConfigs.styles?.bodyClass">
      @for (item of formConfigs.items; track $index) {
        @if (!item.hidden?.()) {
          <div [ngClass]="getItemClass(item)" style="display: flex; flex-flow: column; justify-content: center;">
            @switch (item.controlType) {
              @case (controlType.INPUT) {
                <div class="row">
                  @if (item.label) {
                    <div [ngClass]="['col-sm-' + (item.labelDirection === 'horizontal' ? (item?.columnClass?.labelColumn ?? 2) : 12), item?.customTitleClass || '']">
                      <mat-label class="mat-subtitle-2 f-w-600 d-block" [ngClass]="{ required: hasRequired(item), 'm-b-8': item.labelDirection !== 'horizontal' }">
                        {{ item.orderNumber ? item.orderNumber + '. ' : '' }}{{ item.label | translate }}
                      </mat-label>
                    </div>
                  }
                  <div [ngClass]="['col-sm-' + (item.labelDirection === 'horizontal' ? (item?.columnClass?.controlColumn ?? 10) : 12),item.customInputClass || '']">
                    <mat-form-field appearance="outline" class="w-100 tight-input" subscriptSizing="dynamic">
                      <input #dynamicElements
                        matInput
                        appEmptyToNull
                        [id]="item.key + '_' + formConfigs.id"
                        [formControlName]="item.key"
                        [placeholder]="item.inputConfig?.placeholder || ''"
                        [appUppercaseValue]="item.inputConfig?.isUppercaseValue"
                        [appDecimalOnly]="item.inputConfig?.isDecimalOnly"
                        [appIntegerOnly]="item.inputConfig?.isIntegerOnly"
                        [appMaxLength]="item.inputConfig?.maxLength"
                        [type]="(item.inputConfig?.isPassword && !item.inputConfig?.showingPassword) ? 'password' : 'text'"
                        (blur)="onBlur(item, $event)"/>
                        @if (item.inputConfig?.isPassword) {
                          <button class="password-icon" mat-icon-button matSuffix (click)="toggleShowPassword($event, item)">
                            <mat-icon>{{ item.inputConfig?.showingPassword ? "visibility_off" : "visibility" }}</mat-icon>
                          </button>
                        }
                      </mat-form-field>
                      <ng-container *ngTemplateOutlet="errorTemplate; context: { $implicit: item }"/>
                    </div>
                  </div>
                }
                @case (controlType.SELECT) {
                  <div class="row">
                    @if (item.label) {
                      <div [ngClass]="item.labelDirection === 'horizontal' ? 'col-sm-2' : 'col-sm-12'">
                        <mat-label class="mat-subtitle-2 f-w-600 d-block" [ngClass]="{ required: hasRequired(item), 'm-b-8': item.labelDirection !== 'horizontal' }">
                          {{ item.label | translate }}
                        </mat-label>
                      </div>
                    }
                    <div [ngClass]="item.labelDirection === 'horizontal' ? 'col-sm-10' : 'col-sm-12'">
                      <app-form-select #dynamicElements
                        [placeholder]="item.selectionConfig?.placeholder ?? ''"
                        [formControlName]="item.key"
                        [fetchData]="item.fetchDataAPI"
                        [mapApiResponse]="item.mapApiResponse"
                        [dataSource]="item?.dataSource ?? []"
                        [selectionConfig]="item?.selectionConfig ?? {}">
                      </app-form-select>
                      <ng-container *ngTemplateOutlet="errorTemplate; context: { $implicit: item }"/>
                    </div>
                  </div>
                }
                @case (controlType.AUTOCOMPLETE) {
                  <div class="row">
                    @if (item.label) {
                      <div [ngClass]="'col-sm-' + (item.labelDirection === 'horizontal' ? (item?.columnClass?.labelColumn ?? 2) : 12)">
                        <mat-label class="mat-subtitle-2 f-w-600 d-block" [ngClass]="{ required: hasRequired(item), 'm-b-8': item.labelDirection !== 'horizontal' }">
                          {{ item.label | translate }}
                        </mat-label>
                      </div>
                    }
                    <div [ngClass]="'col-sm-' + (item.labelDirection === 'horizontal' ? (item?.columnClass?.controlColumn ?? 10) : 12)">
                      <app-autocomplete #dynamicElements
                        [placeholder]="item.selectionConfig?.placeholder ?? ''"
                        [formControlName]="item.key"
                        [dataSource]="item?.dataSource ?? []"
                        [fetchData]="item.fetchDataAPI"
                        [mapApiResponse]="item.mapApiResponse"
                        [selectionConfig]="item?.selectionConfig ?? {}"
                        [class]="formGroup.get(item.key)?.invalid && formGroup.get(item.key)?.touched ? 'mat-form-field-invalid' : ''">
                      </app-autocomplete>
                      <ng-container *ngTemplateOutlet="errorTemplate; context: { $implicit: item }"/>
                    </div>
                  </div>
                }
                @case (controlType.TEXTAREA) {
                  <div class="row">
                    @if (item.label) {
                      <div [ngClass]="item.labelDirection === 'horizontal' ? 'col-sm-2' : 'col-sm-12'">
                        <mat-label class="mat-subtitle-2 f-w-600 d-block" [ngClass]="{ required: hasRequired(item), 'm-b-8': item.labelDirection !== 'horizontal' }">
                          {{ item.label | translate }}
                        </mat-label>
                      </div>
                    }
                    <div [ngClass]="item.labelDirection === 'horizontal' ? 'col-sm-10' : 'col-sm-12'">
                      <mat-form-field appearance="outline" class="w-100 tight-input" subscriptSizing="dynamic">
                        <textarea #dynamicElements [rows]="item.inputConfig?.textareaRows" [formControlName]="item.key" [id]="item.key" matInput appEmptyToNull></textarea>
                      </mat-form-field>
                      <ng-container *ngTemplateOutlet="errorTemplate; context: { $implicit: item }"/>
                    </div>
                  </div>
                }
                @case (controlType.CHECKBOX) {
                  <mat-checkbox #dynamicElements color="primary" [formControlName]="item.key">
                    {{ item.label ?? '' | translate }}
                  </mat-checkbox>
                }
                @case (controlType.TEXT) {
                  @if (item.label) {
                    <div>
                      <mat-label class="mat-subtitle-2 d-block m-b-12">
                        {{ item.label | translate }}
                      </mat-label>
                    </div>
                  }
                }
                @case (controlType.SWITCH) {
                  <div class="custom-slide-toggle">
                    <mat-slide-toggle #dynamicElements color="primary" [formControlName]="item.key">
                      {{ item.label ?? '' | translate }}
                    </mat-slide-toggle>
                  </div>
                }
                @case (controlType.DATEPICKER) {
                  <div class="row">
                    @if (item.label) {
                      <div [ngClass]="item.labelDirection === 'horizontal' ? 'col-sm-2' : 'col-sm-12'">
                        <mat-label class="mat-subtitle-2 f-w-600 d-block" [ngClass]="{ required: hasRequired(item), 'm-b-8': item.labelDirection !== 'horizontal' }">
                          {{ item.label | translate }}
                        </mat-label>
                      </div>
                    }
                    <div [ngClass]="item.labelDirection === 'horizontal' ? 'col-sm-10' : 'col-sm-12'">
                      <app-form-date-picker #dynamicElements [formControlName]="item.key" [datePickerConfig]="item?.datePickerConfig ?? {}" />
                      <ng-container *ngTemplateOutlet="errorTemplate; context: { $implicit: item }"/>
                    </div>
                  </div>
                }
                @case (controlType.RADIO) {
                  <div class="row">
                    @if (item.label) {
                      <div [ngClass]="item?.customTitleClass">
                        <mat-label class="mat-subtitle-2 f-w-600 d-block" [ngClass]="{ required: hasRequired(item), 'm-b-8': item.labelDirection !== 'horizontal' }">
                          {{ item.label | translate }}
                        </mat-label>
                      </div>
                    }
                    <div [ngClass]="item?.customCellClass">
                      <mat-radio-group [ngClass]="(formGroup.controls[item.key].errors && formGroup.controls[item.key].touched)  ? 'custom-error-radio':''"  #dynamicElements [formControlName]="item.key">
                        @for (option of item.dataSource; track option.value) {
                          <mat-radio-button [value]="option.value" [disabled]="item?.disable?.()" color="primary">
                            {{ option.text | translate }}
                          </mat-radio-button>
                        }
                      </mat-radio-group>
                    </div>
                  </div>
                }
                @case (controlType.FILE) {
                  <div class="row w-100 m-x-0">
                    @if (item.label) {
                      <div [ngClass]="item.labelDirection === 'horizontal' ? 'col-sm-2' : 'col-sm-12'">
                        <mat-label class="mat-subtitle-2 f-w-600 d-block" [ngClass]="{ required: hasRequired(item), 'm-b-8': item.labelDirection !== 'horizontal' }">
                          {{ item.orderNumber ? item.orderNumber + '. ' : '' }}{{ item.label | translate }}
                        </mat-label>
                      </div>
                    }
                    <div [hidden]="item.isHiddenInput" [ngClass]="item.labelDirection === 'horizontal' ? 'col-sm-10 d-flex align-items-center m-b-6' : 'col-sm-12'">
                      <app-select-file #dynamicElements [formGroup]="formGroup" [fileSelectConfig]="item?.fileSelectConfig ?? {}" [controlName]="item.key" />
                    </div>
                  </div>
                  <div class="p-l-16"><ng-container *ngTemplateOutlet="errorTemplate; context: { $implicit: item }"/></div>
                }
                @case (controlType.RADIO_SQUARE) {
                  <div class="row">
                    @if (item.label) {
                      <div [ngClass]="item?.customTitleClass">
                        <mat-label class="mat-subtitle-2 f-w-600 d-block"
                          [ngClass]="{ required: hasRequired(item), 'm-b-8': item.labelDirection !== 'horizontal' }">
                          {{ item.label | translate }}
                        </mat-label>
                      </div>
                      @if (item.description) {
                        <span [ngClass]="item?.customDescriptionClass">
                          {{ item.description | translate }}
                        </span>
                      }
                    }
                    <div [ngClass]="item?.customCellClass">
                      <div class="custom-checkbox-group">
                        @for (option of item.dataSource; track option.value) {
                          <mat-checkbox
                            [checked]="formGroup.controls[item.key].value === option.value"
                            (change)="onChange($event, item, option)"
                            [disabled]="item?.disable?.()"
                            color="primary"
                            class="custom-checkbox">
                            {{ option.text | translate }}
                          </mat-checkbox>
                        }
                      </div>
                      <ng-container *ngTemplateOutlet="errorTemplate; context: { $implicit: item }"/>
                    </div>
                  </div>
                }
                @case (controlType.INPUT_INLINE) {
                  <div class="row">
                    @if (item.label) {
                      <div [ngClass]="item?.customTitleClass">
                        <mat-label class="mat-subtitle-2 f-w-600 d-block" [ngClass]="{ required: hasRequired(item), 'm-b-8': item.labelDirection !== 'horizontal' }">
                          {{ item.label | translate }}
                        </mat-label>
                      </div>
                    }
                    <div [ngClass]="item?.customCellClass">
                      <mat-form-field appearance="outline" class="w-100 tight-input" subscriptSizing="dynamic">
                        <input  #dynamicElements
                          matInput
                          [formControlName]="item.key"
                          [id]="item.key"
                          [placeholder]="item.inputConfig?.placeholder ?? ''" appEmptyToNull
                          [appDecimalOnly]="item.inputConfig?.isDecimalOnly"
                          [appIntegerOnly]="item.inputConfig?.isIntegerOnly"
                          [appMaxLength]="item.inputConfig?.maxLength"
                          [type]="'text'"/>
                        </mat-form-field>
                        <ng-container *ngTemplateOutlet="errorTemplate; context: { $implicit: item }"/>
                      </div>
                    </div>
                  }
                  @case (controlType.DYNAMIC_COMPONENT) {
                    <ng-template *ngComponentOutlet="item.dynamicComponentConfig?.component; inputs: item.dynamicComponentConfig?.inputs"/>
                    <div><ng-container *ngTemplateOutlet="errorTemplate; context: { $implicit: item }"/></div>
                  }
                  @case (controlType.SELECT_IMAGE) {
                    <div class="row">
                      @if (item.label) {
                        <div [ngClass]="item.labelDirection === 'horizontal' ? 'col-sm-2' : 'col-sm-12'">
                          <mat-label class="mat-subtitle-2 f-w-600 d-block"
                            [ngClass]="{ required: hasRequired(item), 'm-b-8': item.labelDirection !== 'horizontal' }">
                            {{ item.label | translate }}
                          </mat-label>
                        </div>
                      }
                      <div [ngClass]="item.labelDirection === 'horizontal' ? 'col-sm-10' : 'col-sm-12'">
                        <mat-form-field appearance="outline" class="tight-input dropdown"
                          style="width: 100%;" subscriptSizing="dynamic"
                          [ngClass]="{ 'mat-form-field-invalid': formGroup.get(item.key)?.invalid && formGroup.get(item.key)?.touched }">
                          <mat-select [formControlName]="item.key" [id]="item.key">
                            <mat-select-trigger>
                              @for (code of item.dataSelectConfig; track code.value) {
                                @if (code.value === formGroup.get(item.key)?.value) {
                                  <div style="display: flex; gap: 8px; align-items:center">
                                    <img [src]="code.image" alt="" width="20" height="15" style="object-fit: cover;" />
                                    <div>{{code.label}}</div>
                                  </div>
                                }
                              }
                            </mat-select-trigger>
                            @for (code of item.dataSelectConfig; track code.value) {
                              <mat-option [value]="code.value">
                                <div style="display: flex; align-items: center; gap:8px">
                                  <img [src]="code.image" alt="" width="20" height="15" style="object-fit: cover;"/>
                                  <span>{{ code.label }}</span>
                                </div>
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                        <ng-container *ngTemplateOutlet="errorTemplate; context: { $implicit: item }"/>
                      </div>
                    </div>
                  }
                  @case (controlType.DROPDOWN_SELECTOR_INPUT) {
                    <div class="row">
                      @if (item.label) {
                        <div [ngClass]="item.labelDirection === 'horizontal' ? 'col-sm-2' : 'col-sm-12'">
                          <mat-label class="mat-subtitle-2 f-w-600 d-block"
                            [ngClass]="{ required: hasRequired(item), 'm-b-8': item.labelDirection !== 'horizontal' }">
                            {{ item.label | translate }}
                          </mat-label>
                        </div>
                      }
                      <div [ngClass]="item.labelDirection === 'horizontal' ? 'col-sm-10' : 'col-sm-12'">
                        <div class="d-flex custom-dropdown-select-input">
                          <mat-form-field appearance="outline" class="tight-input dropdown radius-left"
                            style="width: 85px;" subscriptSizing="dynamic"
                            [ngClass]="{ 'mat-form-field-invalid': formGroup.get(item.key)?.invalid && formGroup.get(item.key)?.touched }">
                            <mat-select [formControlName]="item.inputConfig?.countryCodeKey ?? ''" [id]="item.inputConfig?.countryCodeKey ?? ''">
                              @if (item.inputConfig?.countryCodeKey; as key) {
                                <mat-select-trigger>
                                  @for (code of item.inputConfig?.countryCodes; track code.value) {
                                    @if (code.value === formGroup.get(key)?.value) {
                                      <img [src]="code.image" alt="" width="20" height="15" style="object-fit: cover;" />
                                    }
                                  }
                                </mat-select-trigger>
                              }
                              @for (code of item.inputConfig?.countryCodes; track code.value) {
                                <mat-option [value]="code.value">
                                  <div style="display: flex; align-items: center;">
                                    <img [src]="code.image" alt="" width="20" height="15" style="object-fit: cover;"/>
                                    <span>{{ code.label }}</span>
                                  </div>
                                </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="flex-grow-1 tight-input input radius-right" subscriptSizing="dynamic">
                            <input matInput
                              [formControlName]="item.key"
                              [id]="item.key"
                              [placeholder]="item.inputConfig?.placeholder ?? ''"
                              appEmptyToNull
                              [appUppercaseValue]="item.inputConfig?.isUppercaseValue"
                              [appDecimalOnly]="item.inputConfig?.isDecimalOnly"
                              [appIntegerOnly]="item.inputConfig?.isIntegerOnly"
                              [appMaxLength]="item.inputConfig?.maxLength"/>
                            </mat-form-field>
                          </div>
                          <ng-container *ngTemplateOutlet="errorTemplate; context: { $implicit: item }"/>
                        </div>
                      </div>
                    }
                  }
                </div>
              }
            }
          </mat-card-content>
          @if(formConfigs.actions) {
            <mat-card-actions [ngClass]="formConfigs.styles?.footerClass">
              @for (btnConfig of formConfigs.actions; track $index) {
                @if (!btnConfig.hidden?.()) {
                  <app-form-button [appearance]="appearance" [spinLoader]="spinLoader" [btnConfig]="btnConfig" [ngClass]="btnConfig.layoutClass" />
                }
              }
            </mat-card-actions>
          }
        </form>
      </div>

      <ng-template #errorTemplate let-item>
        @if (!item.alwaysHideErrorMsg) {
          <mat-error>
            @for (error of getErrorMessage(item); track $index) {
              <span><mat-icon class="error-icon">error_outline</mat-icon> {{ error }} <br></span>
            }
          </mat-error>
        }
      </ng-template>
